import { message } from "antd";

// Credit documents are identified by filename (name + extension), compared case-insensitively.
// The server rejects a re-upload of an attached filename with SERVER_DUPLICATE_MESSAGE;
// the UI replaces it with its own wording.
const SERVER_DUPLICATE_MESSAGE = "Document already uploaded for this alert";

export const normalizeFilename = (name) => (name || "").trim().toLowerCase();

export const isDuplicateResult = (result) => !!result && !result.status && result.message === SERVER_DUPLICATE_MESSAGE;

export const duplicateMessage = (t) => t("contents.alerts.document_already_attached") || "Document already attached to this alert";

// A fixed key collapses the banners into one when several duplicates are dropped at once.
export const showDuplicateError = (t, filename) => {
    message.error({ content: `${filename}: ${duplicateMessage(t)}`, key: "credit-document-duplicate", duration: 5 });
};

// Server per-file result message, with the duplicate rejection reworded.
export const resultMessage = (t, result) => (isDuplicateResult(result) ? duplicateMessage(t) : result.message);
